import { VFC } from "react";
import { DocumentReference } from "firebase/firestore";
import { Game } from "../../../utils/Game";
import { GameMaster } from "./GameMaster/GameMaster";
import { GameMember } from "./GameMember/GameMember";

export const GameStatusSection: VFC<{
  isGameMaster: boolean;
  small?: boolean;
  game?: Game;
  gameRef: DocumentReference;
}> = ({ isGameMaster, game, gameRef, small = false }) => {
  if (isGameMaster) {
    return <GameMaster small={small} game={game} gameRef={gameRef} />;
  }

  return <GameMember small={small} game={game} />;
};
